import React from 'react';
import {Body, Label, designSystemToken} from '@lightricks/react-design-system';
import getEngagementRateString from '@/utils/getEngagementRateString';
import getFollowersCountString from '@/utils/getFollowersCountString';
import translate from '@/utils/translate';
import {SocialNetworkInfo} from '@/types/socials';
import styles from './CreatorSocialInfo.module.scss';

type SocialInfoProps = {
  leadPlatformInfo: SocialNetworkInfo | undefined;
};

function CreatorSocialInfo({leadPlatformInfo}: SocialInfoProps) {
  if (!leadPlatformInfo) {
    return null;
  }
  const isYoutube = leadPlatformInfo.provider === 'youtube';
  const textColor = designSystemToken('semantic.fg.primary');
  const followersLabel = isYoutube
    ? translate('Subscribers')
    : translate('Followers');
  const engLabel = isYoutube ? translate('Avg Eng') : translate('Eng Rate');
  const {followersCount, engagementRate} = leadPlatformInfo;

  return (
    <div className={styles.container}>
      {followersCount != null ? (
        <div className={styles.stat}>
          <Label size="md" color={textColor}>
            {getFollowersCountString(followersCount)}
          </Label>
          <Body size="sm" color={textColor}>
            {followersLabel}
          </Body>
        </div>
      ) : null}
      {engagementRate != null ? (
        <div className={styles.stat}>
          <Label size="md" color={textColor}>
            {getEngagementRateString(engagementRate)}
          </Label>
          <Body size="sm" color={textColor}>
            {engLabel}
          </Body>
        </div>
      ) : null}
    </div>
  );
}

export default CreatorSocialInfo;
